import React, {Component} from "react";
import {Link} from "react-router-dom";
import FeedbackPublicationRepository from "../../repository/FeedbackPublicationRepository";
import ReactPaginate from "react-paginate";
import {strings} from "../../Localization/Localization";
import InfoPopup from "../ErrorHandler/InfoPopup";
import FileSaver from "file-saver"
import Moment from 'moment';
import "./css/MyFeedbackPublications.css";
import {
    faCalendarAlt,
    faCalendarPlus, faChevronRight,
    faDownload,
    faSearch,
    faUniversity,
    faUser
} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import moment from "moment";
import {Button} from "@material-ui/core";
import SpinnerComponent from '../Spinner/spinner.component';


class MyProactiveTransparencyPublications extends Component {
    constructor(props) {
        super(props);
        this.state = {
            feedbackpubs: [],
            pageCount: 1,
            numOfElements: 0,
            activeLanguage: localStorage.getItem("activeLanguage"),
            spinner: false,
        }
    }

    componentDidMount() {
        this.fetchData();
        strings.setLanguage(localStorage.getItem("activeLanguage"));
        this.setState({});
    }

    fetchData = (selectedPage = 0) => {
        let institutionId = localStorage.getItem('institutionId');
        let areas = localStorage.getItem('areas').split(";");
        this.setState({spinner: true});
        FeedbackPublicationRepository.getProactivityForInstitution(institutionId, selectedPage).then(res => {
            let contentData = res.data.content;
            let listFeedbacks = []
            for(let i=0; i<contentData.length; i++){
                for(let j=0; j<areas.length; j++){
                    if(contentData[i].feedback?.areaOfInterest?.nameMk === areas[j]){
                        listFeedbacks.push(contentData[i]);
                    }
                }
            }
            this.setState({
                numOfElements: listFeedbacks.length,
                feedbackpubs: listFeedbacks,
                pageCount: res.data.totalPages,
                spinner: false,
            })
        }).catch(err => {
            this.setState({spinner: false});
            console.log(err)
        })
    }

    handlePageClick = data => {
        this.fetchData(data.selected);
    };

    renderFeedbackPub = feedpub => {
        let currentDate = new Date();
        currentDate.setHours(0,0,0,0)
        let dueDate = new Date(feedpub.feedback.dueDate)
        dueDate.setHours(0,0,0,0)
        console.log("currentDate: ", currentDate)
        console.log("dueDate: ", dueDate)
        let button =  feedpub.finished
            ?
            (<Link to={"/visualizeAnswers/" + feedpub.id}
                   className="btn myFeedbackPublicationsButton mb-2"
                   style={{color: 'white', background: '#7495b2', border: '1px solid #584b4b'}}>
                <FontAwesomeIcon icon={faSearch} size="lg"
                                 style={{paddingRight: '4px'}}
                />{strings.previewAnswer}
            </Link>)
            :
            currentDate<=dueDate ?
            (<Link to={"/visualizeFeedback/" + feedpub.id}
                   className="btn myFeedbackPublicationsButton mb-2"
                   style={{color: 'black', background: '#80c6db'}}>
                <FontAwesomeIcon icon={faChevronRight} size="lg"
                                 style={{paddingRight: '4px'}}
                />
                {strings.answer}
            </Link>) : <></>;
        const formatDate = Moment().format('DD-MM-YYYY')
        let showAnalyse = feedpub.finishedFromAdmin &&
            (
                <Button
                    onClick={() => fetch(`${process.env.REACT_APP_HOST_ENV}rest/feedback/export/${feedpub.feedback.id}`,
                    {
                        origin: 'same-origin',
                        headers: {
                            Authorization: "Bearer " + localStorage.getItem('auth_token')
                        }
                    }
                    ).then(res => res.blob())
                        .then(file => FileSaver.saveAs(file, `${feedpub.feedback.name}_споредба_${formatDate}.xlsx`))}
                    className="btn myFeedbackPublicationsButton mr-2 defaultBtn"
                    style={{color: 'black', background: '#cbe7f2'}}>
                    <FontAwesomeIcon icon={faDownload} size="lg"
                                     style={{paddingRight: '4px'}}
                    />
                   <span>{strings.compareData}</span>
                </Button>
            )
        return (
            <div className="row mt-4">
                <div className="col-12 myFeedbackPublicationsContainer">

                    <div className="row w-100">
                        <div className="col-6 mb-2 myFeedbackPublicationsPublicationTitleCol">
                            <h3>{feedpub.feedback.name}</h3>
                        </div>
                        <div className="col-6 mb-2">
                            {button}
                            {showAnalyse}
                        </div>
                    </div>
                    <div className="row myFeedbackPublicationsRowFooter">
                        <div className="col-12 mt-1 myFeedbackPublicationsColFooter">
                            <h6 className="myFeedbackPublicationsFooterText mr-3">
                                <FontAwesomeIcon icon={faUser} size="lg" className="mr-1"/>
                                {feedpub.feedback.creator.firstName + " " + feedpub.feedback.creator.lastName}
                            </h6>
                            <h6 className="myFeedbackPublicationsFooterText mr-3">
                                <FontAwesomeIcon icon={faUniversity} size="lg" className="mr-1"/>
                                {this.state.activeLanguage === 'mk' &&
                                feedpub.institution.nameMk}
                                {this.state.activeLanguage === 'al' &&
                                feedpub.institution.nameAl}
                            </h6>
                            <h6 className="myFeedbackPublicationsFooterText">
                                <FontAwesomeIcon icon={faCalendarPlus} size="lg" className="mr-2"/>
                                {feedpub.dateCreated}
                            </h6>
                            <h6 className="myFeedbackPublicationsFooterText myFeedbackPublicationsFooterRightText">
                                {strings.dueDate + ":   "}<FontAwesomeIcon icon={faCalendarAlt} size="lg"
                                                                           className="mr-2"/>
                                {moment(feedpub.feedback.dueDate).local().format('DD-MM-YYYY')}
                            </h6>
                        </div>
                    </div>

                </div>
            </div>
        )
    }

    render() {
        if(this.state.spinner){
            return <div className="w-100 h-100 d-flex justify-content-center align-items-center">
                <SpinnerComponent />
            </div>
        }
        else if (this.state.numOfElements !== 0) {
            return (
                <div className="col-12">
                    <div className="row">
                        <div className="col-12">
                            <h2 style={{textAlign: "left", color: "#1C4857"}}
                                className="mt-4">{strings.proactiveTransparency}</h2>
                        </div>
                    </div>
                    {this.state.feedbackpubs.map(this.renderFeedbackPub)}
                    <div className="row">

                        <ReactPaginate
                            previousLabel={"<<"}
                            nextLabel={">>"}
                            breakLabel={'...'}
                            pageCount={this.state.pageCount}
                            marginPagesDisplayed={2}
                            pageRangeDisplayed={5}
                            onPageChange={this.handlePageClick}
                            breakClassName={'page-item'}
                            breakLinkClassName={'page-link'}
                            containerClassName={'pagination'}
                            pageClassName={'page-item'}
                            pageLinkClassName={'page-link'}
                            previousClassName={'page-item'}
                            previousLinkClassName={'page-link'}
                            nextClassName={'page-item'}
                            nextLinkClassName={'page-link'}
                            activeClassName={'active'}
                        />
                    </div>
                </div>
            )
        } else {
            return (
                <div style={{display: 'flex', alignItems: 'center', height: '100%'}}>
                    <InfoPopup infoMessage={strings.noPublishedTransparencies}/>
                </div>
            )
        }

    }

}

export default MyProactiveTransparencyPublications;